import React, { FC } from 'react';
import * as S from './styled';
import { monthImg } from '../../../../img';
import arrows from '../../../../img/arrows.png';

interface Props {
	currentWeight: number;
	goalWeight: number;
	weightUnit: string;
	goalDate: string;
	monthsCount: number;
}

export const WeightBlock: FC<Props> = props => {
	const date = new Date();
	const {
		currentWeight = 85,
		goalWeight = 84,
		goalDate = '2 Sep, 2023',
		weightUnit,
		monthsCount = 3,
	} = props;

	return (
		<S.Container>
			<S.Left className='left'>
				<div>
					<span className='weight'>
						{currentWeight} {weightUnit}
					</span>
					<S.Date>
						{date.toLocaleDateString('en-US', {
							year: 'numeric',
							month: 'short',
							day: 'numeric',
						})}
					</S.Date>
				</div>
				<div>
					<S.Arrows src={arrows} width={40} height={30} alt='arrows' />
				</div>
			</S.Left>
			<S.Right className='right'>
				<S.Arrows src={arrows} width={40} height={30} alt='arrows' />
				<div>
					<span className='weight'>
						{goalWeight} {weightUnit}
					</span>
					<S.Date>{goalDate}</S.Date>
				</div>
			</S.Right>
			<S.MonthPlan
				src={monthImg[monthsCount <= 12 ? monthsCount : 12]}
				alt={`monthPlan${monthsCount}`}
			/>
		</S.Container>
	);
};
